import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import style from './Directions.module.css';
import HeadSub from '../../../../components/comm/HeadSub';

import mapImg011 from '../../../../images/user/img_map_011.png'; //여의도
import mapImg012 from '../../../../images/user/img_map_012.png'; //서울  
import mapImg013 from '../../../../images/user/img_map_013.png'; //의정부 
import mapImg014 from '../../../../images/user/img_map_014.png'; //부천
import mapImg015 from '../../../../images/user/img_map_015.png'; //은평
import mapImg016 from '../../../../images/user/img_map_016.png'; //인천
import mapImg018 from '../../../../images/user/img_map_018.png'; //대전

import imgEunpyeong01 from '../../../../images/user/img_bus_Eunpyeong_01.svg';
import imgEunpyeong02 from '../../../../images/user/img_bus_Eunpyeong_02.svg';
import imgBucheon01 from '../../../../images/user/img_bus_Bucheon_01.svg';
import imgBucheon02 from '../../../../images/user/img_bus_Bucheon_02.svg';
import imgBucheon03 from '../../../../images/user/img_subway_Bucheon.svg';

//Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const Directions = () => {

    const location = useLocation();
    const { hsptlCd } = location.state || {};

    const hospitCds = hsptlCd;

    
    const hospitalAddresses = {
        "012": {
            name: "서울성모병원",
            addressLines: ["서울 서초구 반포대로 222", "가톨릭대학교 서울성모병원(06591)"],
            map: mapImg012,
        },
        "011": {
            name: "여의도성모병원",
            addressLines: ["서울시 영등포구 63로 10", "가톨릭대학교 여의도성모병원 (우) 07345"],
            map: mapImg011,
        },
        "015": {
            name: "은평성모병원",
            addressLines: ["서울시 은평구 통일로 1021", "가톨릭대학교 은평성모병원"],
            map: mapImg015,
        },
        "013": {
            name: "의정부성모병원",
            addressLines: ["(11765)경기도 의정부시 천보로 271", "가톨릭대학교 의정부성모병원"],
            map: mapImg013,
        },
        "014": {
            name: "부천성모병원",
            addressLines: ["경기도 부천시 원미구 소사로327 (14647)", "가톨릭대학교 부천성모병원"],
            map: mapImg014,
        },
        "016": {
            name: "인천성모병원",
            addressLines: ["인천광역시 부평구 동수로 56", "가톨릭대학교 인천성모병원"],
            map: mapImg016,
        },
        "018": {
            name: "대전성모병원",
            addressLines: ["(34943) 대전광역시 중구 대흥로 64(대흥동)", "가톨릭대학교 대전성모병원"],
            map: mapImg018,
        },
    };

    const hospital = hospitalAddresses[hospitCds];

    //Accordion
    const [expanded, setExpanded] = React.useState('panel1');

    const acHandleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    
    return (
        <>
            <HeadSub title="오시는 길" hospitalName={hospital.name}/>

                <div id="sub-content" data-type="b" data-layout="white">
                    <div className='inner-wrap' data-pad="normal">

                        <div className={style['top-box']}>
                            <strong className={style['address-txt']}>

                                {hospital && (
                                    <div className={style['cont-box']}>
                                        {hospital.addressLines.map((line, index) => (
                                            <p key={index}>{line}</p>
                                        ))}
                                    </div>
                                )}   
                            </strong>

                            <div className={style['map-box']}>
                                {hospital?.map && (
                                    <object data={hospital.map} alt={`${hospital.name} 지도`} aria-hidden='true'/>
                                )}
                            </div>
                        </div>    
                        
                            
                        <div className={style['mid-box']}>
                            <div className="accordion-wrap" data-type="c">

                                {/* 서울성모병원 :: S */}
                                {hospitCds === "012" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    셔틀버스 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="2">2호선</span>
                                                                    <p>서초역 7번 출구 앞</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="7">7호선</span>
                                                                    <p>고속터미널역 3번 출구 앞</p>        
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"38.1%"} />
                                                                    <col width={"30.9%"} />
                                                                    <col width={"auto"} />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr>
                                                                        <th></th>
                                                                        <th>평일</th>
                                                                        <th>토요일</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <th>원내 첫차 출발 시간</th>
                                                                        <td>오전 8시</td>
                                                                        <td>오전 8시 30분</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>원내 막차 출발 시간</th>
                                                                        <td>오후 6시</td>
                                                                        <td>오후 12시 30분</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>비고</th>
                                                                        <td>10분 간격</td>
                                                                        <td>30분 간격</td>
                                                                    </tr>
                                                                </tbody>   
                                                            </table>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    대중버스 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">간선</span>
                                                                    <strong>서울지방조달청방면 서울성모병원</strong>
                                                                    <p>740, 405</p>
                                                                </li>
                                                                <li>
                                                                    <strong>서울성모병원</strong>
                                                                    <p>고속터미널역 3번 출구 앞</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>고속터미널방면 100번대</strong>
                                                                    <p>142, 143, 148</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>300번대</strong>
                                                                    <p>351, 360</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>400번대</strong>
                                                                    <p>401</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>600번대</strong>
                                                                    <p>640, 642, 643</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">지선</span>
                                                                    <strong>고속터미널</strong>
                                                                    <p>4212, 6411, 3012, 4318, 3414, 3422(센트럴시티), 서초10, 서초14</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>서울지방조달청방면 서울성모병원 </strong>
                                                                    <p>5413, 서초13, 서초14, 서초21</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="wide">광역</span>
                                                                    <strong>고속터미널</strong>
                                                                    <p>9408, 9500, 9802, 9501, 9502</p>        
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="2">2호선</span>
                                                                    <p>서초역 7번 출구</p>
                                                                    <p className={style['star-txt']}>서초역에서 내릴 경우 셔틀버스를 이용해주세요 (서울성모병원까지 거리 약 1km)</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="3">3호선</span>
                                                                    <p>고속터미널역 가톨릭의과대학방면 2, 7번 출구</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="7">7호선</span>    
                                                                    <p>고속터미널역 가톨릭의과대학방면 2, 7번 출구</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="9">9호선</span>    
                                                                    <p>고속터미널역 가톨릭의과대학방면 2, 3, 4, 7번 출구</p>
                                                                    <p className={style['star-txt']}>
                                                                        고속터미널역 3번 출구 → 셔틀버스 이용
                                                                        고속터미널역 4번 출구 → 도보 5분 이동
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>        
                                                </div>
                                            </AccordionDetails> 
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    승용차 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body" data-pad-side="0">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"32.89%"} />
                                                                    <col width={"auto"} />
                                                                </colgroup>
                                                                <tbody>
                                                                    <tr>
                                                                        <th>경부고속도로</th>
                                                                        <td className='text-align-left'>반포IC(고속터미널 방향) → 첫 번째 사거리 → 직진 200미터 전방 → 지하차도(사평 지하차도) 위 → 유턴 후 20미터 → 서울성모병원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>중부고속도로</th>
                                                                        <td className='text-align-left'>동수원 톨게이트 → 김포방향 올림픽도로 직진 → 한남대교 밑(경부고속도로 진입로 방향) → 우측 고속터미널 방향으로 직진 → 뉴코아 백화점앞 경유 → 첫번째 (강남고속터미널 앞) 사거리에서 언덕 사거리까지 직진 후, 우회전 → 200미터 전방-지하(사평)차도 위 유턴 후 20미터 → 서울성모병원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>서해안고속도로</th>
                                                                        <td className='text-align-left'>발안IC-과천방향 → 남태령 → 사당사거리 우회전 → 예술의 전당 앞 삼거리에서 죄회전 후 직진 → 서초경찰서 고개 넘어 70미터(우측) → 서울성모병원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>의정부/동두천/포천</th>
                                                                        <td className='text-align-left'>동부간선도로 → 성수대교 끝부분에서 올림픽대로(김포방향) 진입 → 한남대교 밑(경부고속도로 진입로 방향) → 우측 고속터미널 방향으로 직진 → 뉴코아 백화점 앞 경유 → 첫번째 (강남고속터미널 앞) 사거리에서 언덕 사거리까지 직진 후, 우회전 → 200미터 전방 → 지하(사평)차도 위 유턴 후 20미터 → 서울성모병원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>올림픽대로 (김포방향에서)</th>
                                                                        <td className='text-align-left'>김포대교 → 양화대교 → 반포대교 우측으로 빠져서 → 고가도로 진입 → 사거리에서 직진(50미터 전방) → 서울성모병원</td>
                                                                    </tr>
                                                                    
                                                                </tbody>   
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel5'} onChange={acHandleChange('panel5')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel5-content"
                                                id="panel5-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    인천국제공항 공항버스 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <p>항공노선을 이용하시는 분은 인천국제공항에서 공항버스 (공항리무진)를 이용하실 수 있습니다.</p>

                                                        <hr />

                                                        <div className={style['txts-box']}>
                                                            <strong>가락시장 방향 (6009번)</strong>
                                                            <p><b>정차장 번호</b> : 5A, 11B</p>
                                                            <p className={style['column']}><b>경유지</b>
                                                                인천공항→구반포→강남고속버스터미널→논현역→강남역
                                                            </p>
                                                            <p><b>문의처</b> : 서울공항리무진㈜ 02-577-1343~5</p>
                                                        </div>

                                                        <hr />

                                                        <div className={style['txts-box']}>
                                                            <strong>잠실 방향 (6000번)</strong>
                                                            <p><b>정차장 번호</b> : 6A, 12B</p>
                                                            <p className={style['column']}><b>경유지</b>
                                                                인천공항→김포공항→리버파크호텔→쉐라톤 서울 팔래스 강남 호텔→강남고속버스터미널→리츠칼튼호텔→삼성역
                                                            </p>
                                                            <p><b>문의처</b> :  (주)공항리무진 02-2664-9898, 9776</p>
                                                        </div>

                                                        <hr />

                                                        <div className={style['txts-box']}>
                                                            <strong>역삼역 방향 (6020번)</strong>
                                                            <p><b>정차장 번호</b> : 4A, 10A</p>
                                                            <p className={style['column']}><b>경유지</b>
                                                                인천공항↔강남고속버스터미널(센트럴시티, 메리어트호텔)
                                                            </p>
                                                            <p><b>문의처</b> :  서울공항리무진㈜ 02-577-1343~5</p>
                                                        </div>

                                                        <hr />

                                                        <div className={style['txts-box']}>
                                                            <strong>사평역 방향 (6703번)</strong>
                                                            <p><b>정차장 번호</b> : 4B, 11A</p>
                                                            <p className={style['column']}><b>경유지</b>
                                                                인천공항→쉐라톤 서울 팔래스 강남 호텔 경유(하차)→코엑스인터콘티넨탈호텔→아마가호텔
                                                            </p>
                                                            <p><b>문의처</b> :  (주)대한항공 KAL리무진 02-2667-0386~89</p>
                                                        </div>

                                                        <hr />


                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}
                                {/* 서울성모병원 :: E */}
                                


                                {/* 여의도성모 :: S */}
                                {hospitCds === "011" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    셔틀버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="1">1호선</span>
                                                                    <p>대방역 7번 출구 여의교 방면 100m 교통섬(샛강역 경유)</p>        
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"32.89%"} />
                                                                    <col width={"auto"} />
                                                                </colgroup>
                                                                <tbody>
                                                                    <tr>
                                                                        <th>대방역 출발</th>
                                                                        <td className='text-align-left'>07:10 ~ 17:55 (10분, 25분, 40분, 55분)</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>병원 출발</th>
                                                                        <td className='text-align-left'>07:05 ~ 17:50 (05분, 20분, 35분, 50분)</td>
                                                                    </tr>
                                                                </tbody>   
                                                            </table>
                                                        </div>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <div className={style['span-group']}>
                                                                        <span className={style['mark-box']} data-mark="5">5호선</span>
                                                                        <span className={style['mark-box']} data-mark="9">9호선</span>
                                                                    </div>
                                                                    <p>여의도역 5번 출구 10m앞 → 병원</p>        
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"32.89%"} />
                                                                    <col width={"auto"} />
                                                                </colgroup>
                                                                <tbody>
                                                                    <tr>
                                                                        <th>여의도역 출발</th>
                                                                        <td className='text-align-left'>07:07 ~ 17:47 (7분, 27분, 47분)</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>병원 출발</th>
                                                                        <td className='text-align-left'>07:00 ~ 17:40 (정시 / 20분 / 40분)</td>
                                                                    </tr>
                                                                </tbody>   
                                                            </table>
                                                        </div>

                                                        <div className={style['list-box']} data-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>토요일은 12:40분까지만 운행하며, 공휴일은 운행하지 않습니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    대중/고속버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">마을</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>11번</p>
                                                                    <strong>여의도 한양아파트정류장 하차</strong>
                                                                    <p>영등포 10번 (여의도성모병원 방면으로 650m이동)</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">간선</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>261번</p>
                                                                    <strong>시범아파트, 대교아파트 정류장 하차</strong>
                                                                    <p>700번</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">좌석</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>740, 405</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">지선</span>
                                                                    <strong>시범아파트, 대교아파트 정류장 하차</strong>
                                                                    <p>5012번 (도보 10분)</p>        
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>5634번, 5633번, 7611번</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="wide">직행</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>7007-1번</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="gray">고속</span>
                                                                    <strong>고속버스터미널</strong>
                                                                    <p>(간선) 361번 → 대방역 하차 (7번 출구 앞) → 셔틀버스</p>        
                                                                    <strong>고속버스터미널역</strong>
                                                                    <p>지하철 (9호선) 승차 → 샛강역 하차 → 샛강역 3번 출구 → (지선) 5634번 승차 → 63빌딩 (여의도성모병원) 하차</p>        
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="1">1호선</span>
                                                                    <p>대방역 7번 출구 → 셔틀버스</p>
                                                                </li>
                                                                <li>
                                                                    <div className={style['span-group']}>
                                                                        <span className={style['mark-box']} data-mark="5">5호선</span>    
                                                                        <span className={style['mark-box']} data-mark="9">9호선</span>    
                                                                    </div>
                                                                    <p>여의도역 5번 출구 → 셔틀버스</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="9">9호선</span>    
                                                                    <p>샛강역 3번 출구 → 앙카라공원 안의 산책길 → 샛강생태공원 옆 강길 → 7~10분 도보</p>        
                                                                </li> 
                                                            </ul>
                                                        </div>
                                                    </div>        
                                                </div>
                                            </AccordionDetails> 
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    기차역
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>서울역</strong>
                                                                    <div className={style['list-box']} data-type="b">
                                                                        <ul>
                                                                            <li>
                                                                                <p>서울역 서부 (간선)261번 승차 → 63빌딩 (여의도성모병원) 하차 → 서울역 버스환승센터 (간선)503번, 162번 ,505번 승차 → 시범아파트, 대교아파트 정류장 하차 후 도보 10분</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>서울역 지하철 (1호선) 승차 → 대방역 지하철 (1호선) 하차 → 대방역 7번 출구 → 셔틀버스</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <strong>용산역</strong>
                                                                    <div className={style['list-box']} data-type="b">
                                                                        <ul>
                                                                            <li>
                                                                                <p>용산역 광장앞 (지선) 5012번 승차 → 시범아파트, 대교아파트 정류장 하차 후 도보 10분</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>용산역 지하철 (1호선) 승차 → 대방역 지하철 (1호선) 하차 → 대방역 7번 출구 → 셔틀버스</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                )}
                                {/* 여의도성모 :: E */}


                                {/* 은평성모 :: S */}
                                {hospitCds === "015" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    대중버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">간선</span>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>704번, 708번 (은평성모병원 정류장 도보 3분)</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>720번 (진관동주민센터 정류장 도보 6분)</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>571번, 703번, 705번, 741번, 761번, 774번 (구파발역입구 정류장 도보 6분)</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">지선</span>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>7722번 (은평성모병원 정류장 도보 2분)</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>7211번 (구파발역입구 정류장 도보 6분)</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>7723번 (진관동주민센터 정류장 도보 6분)</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="common">일반</span>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>790번, 730번 (구파발역입구 정류장 도보 6분)</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">마을</span>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>은평 03-2번 버스 (은평성모병원 셔틀버스 승강장) <br />
                                                                                    *2024년 10월 31일부터 운행
                                                                                </p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="3">3호선</span>
                                                                    <p>구파발역 3번 출구 도보 8분</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    셔틀버스 운행안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['img-box']}>
                                                            <object data={imgEunpyeong01} aria-hidden='true'/>
                                                        </div>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>운행시간 <br/> (병원 출발 기준)</strong>
                                                                    <div className={style['list-box']} data-type="c">
                                                                        <ul>
                                                                            <li>
                                                                                <strong>평일</strong>
                                                                                <div className={style['span-group']}>
                                                                                    <span>첫차 06:45, 막차 18:00</span>
                                                                                    <span>매시 00분, 15분, 30분, 45분 (15분 간격)</span>
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <strong>토요일</strong>
                                                                                <div className={style['span-group']}>
                                                                                    <span>첫차 08:00, 막차 12:00</span>
                                                                                    <span>매시 00분, 20분, 40분 (20분 간격)</span>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                
                                                            </ul>
                                                        </div>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>운행시간 <br/> (구파발역 4번 출구 출발 기준) *임시</strong>
                                                                    <div className={style['list-box']} data-type="c">
                                                                        <ul>
                                                                            <li>
                                                                                <strong>평일</strong>
                                                                                <div className={style['span-group']}>
                                                                                    <span>첫차 06:52, 막차 18:07</span>
                                                                                    <span>매시 07분, 22분, 37분, 52분 (15분 간격)</span>
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <strong>토요일</strong>
                                                                                <div className={style['span-group']}>
                                                                                    <span>첫차 08:07, 막차 12:07</span>
                                                                                    <span>매시 07분, 27분, 47분 (20분 간격)</span>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>운행노선</strong>
                                                                    <div className={style['img-box']}>
                                                                        <object data={imgEunpyeong02} alt="" aria-hidden='true'/>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <strong>셔틀버스 승강장 위치</strong>
                                                                    <strong className={style['gray']}>병원</strong>
                                                                    <p>1층 교통광장 내 셔틀버스 승강장</p>
                                                                </li>
                                                                <li>
                                                                    <strong className={style['gray']}>구파발역</strong>
                                                                    <p>구파발역 4번 출구 앞(임시)</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                            <ul>
                                                                <li>
                                                                    <p>본 버스는 예약환자와 보호자만 이용 가능함</p>
                                                                </li>
                                                                <li>
                                                                    <p>운행시간은 교통상황에 의해 변동가능</p>
                                                                </li>
                                                                <li>
                                                                    <p>코로나-19 감염예방을 위해 탑승 시 마스크를 착용해주시기 바랍니다</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>        
                                                </div>
                                            </AccordionDetails> 
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    승용차 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>수도권제1순환고속도로 <br />
                                                                    (김포방향에서 오시는 경우)
                                                                    </strong>
                                                                    <p>수도권제1순환고속도로 → 의정부 방면으로 10km → 통일로 IC 진출 → 통일로 서울(구파발) 방면 2.4km → 소방행정타운 우회전 후 129m이동 → 은평성모병원 본관앞</p>
                                                                </li>
                                                                <li>
                                                                    <strong>수도권제1순환고속도로 <br />
                                                                    (의정부방향에서 오시는 경우)
                                                                    </strong>
                                                                    <p>송추 IC → 북한산로 → 통일로 삼거리(은평지문교) → 구파발 방면 좌회전 → 은평성모병원 1.17km</p>
                                                                </li>
                                                                <li>
                                                                    <strong>강변북로 일산방향</strong>
                                                                    <p>강변북로 일산 방면 → 월드컵대교 북단(증산로 입구) → 월드컵 경기장 → 증산로 → 연신내 역 물빛공원 → 통일로 구파발 방면 좌회전 → 은평성모병원 1.8km</p>
                                                                </li>
                                                                <li>
                                                                    <strong>서울시청 → 구파발 방향</strong>
                                                                    <p>경복궁역 교차로 자하문 지하차도 방면 좌회전 → 세검정 터널방면 우회전 → 세검정로 → 진흥로 방면 좌회전 → 구기터널 → 통일로 구파발 방면 우회전 → 은평성모병원 3.2km</p>
                                                                </li>
                                                                <li>
                                                                    <strong>고양시청 → 구파발 방향</strong>
                                                                    <p>원당역 구파발 방면 → 고양대로(356국도) 원흥 지하차도 진입 → 통일로 서울방면(구파발) 우회전 → 은평성모병원 2.1km</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                )}
                                {/* 은평성모 :: E */}


                                {/* 의정부성모 :: S */}
                                {hospitCds === "013" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    버스 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <strong>의정부성모병원(의정부면허시험장 방면) 정류장</strong>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">시내</span>
                                                                    <p>21, 33, 35, 72, 72-3, 118</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="wide">광역</span>
                                                                    <p>3200, 3500, G2001</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">좌석</span>
                                                                    <p>138, 138-1, 138-5</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">마을</span>
                                                                    <p>206-1, 207, 207-1</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="gray">시외</span>
                                                                    <p>3001, 3002</p>        
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <strong>의정부성모병원(금곡교 방면) 정류장</strong>
        
                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">시내</span>
                                                                    <p>21, 33, 35, 72, 72-3, 118</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="wide">광역</span>
                                                                    <p>3200, 3500, G2001</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">좌석</span>
                                                                    <p>138, 138-1, 138-5</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">마을</span>
                                                                    <p>206-1</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="gray">시외</span>
                                                                    <p>3001, 3002</p>        
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    대중/고속버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">마을</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>11번</p>
                                                                    <strong>여의도 한양아파트정류장 하차</strong>
                                                                    <p>영등포 10번 (여의도성모병원 방면으로 650m이동)</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">간선</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>261번</p>
                                                                    <strong>시범아파트, 대교아파트 정류장 하차</strong>
                                                                    <p>700번</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="trunk">좌석</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>740, 405</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="branch">지선</span>
                                                                    <strong>시범아파트, 대교아파트 정류장 하차</strong>
                                                                    <p>5012번 (도보 10분)</p>        
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>5634번, 5633번, 7611번</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="wide">직행</span>
                                                                    <strong>63빌딩 (여의도성모병원) 하차</strong>
                                                                    <p>7007-1번</p>        
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="gray">고속</span>
                                                                    <strong>고속버스터미널</strong>
                                                                    <p>(간선) 361번 → 대방역 하차 (7번 출구 앞) → 셔틀버스</p>        
                                                                    <strong>고속버스터미널역</strong>
                                                                    <p>지하철 (9호선) 승차 → 샛강역 하차 → 샛강역 3번 출구 → (지선) 5634번 승차 → 63빌딩 (여의도성모병원) 하차</p>        
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="1">1호선</span>
                                                                    <p>1호선 의정부역 하차 → 동부광장 정류장(도보) → 207번 마을버스 승차 → 의정부성모병원 정류장 하차(소요시간 30분)</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="train">의정부경전철</span>    
                                                                    <p>의정부경전철 효자역 하차 → 도보 15분 이동</p>        
                                                                </li> 
                                                            </ul>
                                                        </div>
                                                    </div>        
                                                </div>
                                            </AccordionDetails> 
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    승용차
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>영동고속도로</strong>
                                                                    <p>호법 JC → 중부고속도로 → 수도권제1순환고속도로 구리남양주요금소 → 일동, 의정부방면 진입 → 청학리청학터널 → 만가대사거리에서 우회전 → 포천(43번국도) 직진 → 산들마을 앞에서 좌회전(병원 표지판 있음) → 2.7km직진 → SK LPG주유소 사거리에서 좌회전 → 육교 앞 벽산APT에서 우회전 → 좌회전 → 400M 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>경부고속도로</strong>
                                                                    <p>판교 IC → 하남 IC → 중부고속도로 → 수도권제1순환고속도로 구리남양주요금소 → 일동, 의정부방면 진입 → 청학리청학터널 → 만가대사거리에서 우회전 → 포천(43번국도) 직진 → 산들마을 앞에서 좌회전(병원 표지판 있음) → 2.7km직진 → SK LPG주유소 사거리에서 좌회전 → 육교 앞 벽산APT에서 우회전 → 좌회전 → 400M 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>서해안고속도로</strong>
                                                                    <p>안산 IC → 수도권제1순환고속도로 → 하남 IC → 중부고속도로 → 수도권제1순환고속도로 구리남양주요금소 → 일동, 의정부방면 진입 → 청학리청학터널 → 만가대사거리에서 우회전 → 포천(43번국도) 직진 → 산들마을 앞에서 좌회전(병원 표지판 있음) → 2.7km직진 → SK LPG주유소 사거리에서 좌회전 → 육교 앞 벽산APT에서 우회전 → 좌회전 → 400M 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>서울방향</strong>
                                                                    <p>동부간선도로 → 의정부 → 참서울병원 앞 금신 교차로에서 우회전(포천방면) → 900m직진(42번국도) → 육교 앞 좌회전 1차선 도로로 진입 → 1km 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>남양주방향</strong>
                                                                    <p>퇴계원(43번국도) → 청학리 → 청학터널 → 만가대 사거리에서 우회전 → 포천(43번)국도 직진 → 산들마을 앞에서 좌회전(병원 표지판 있음) → 2.7km직진 → SK LPG 주유소 사거리에서 좌회전 → 육교 앞 벽산아파트 앞에서 우회전 → 좌회전 → 400M 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>고양시방향</strong>
                                                                    <p>송추(39번국도) → 녹양사거리에서 직진 → 우회전 → 금오사거리 → 포천방면으로 좌회전(43번국도) → 육교 앞에서 좌회전 1차선 도로로 진입 → 1km 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>연천방향</strong>
                                                                    <p>동두천(3번국도) → 녹양사거리에서 좌회전 → 우회전 → 금오사거리 → 포천방면으로 좌회전(43번국도)육교 앞 좌회전 1차선 도로로 진입 → 1km 지점 좌측 의정부성모병원</p>
                                                                </li>
                                                                <li>
                                                                    <strong>포천방향</strong>
                                                                    <p>43번국도 → 축석 검문소에서 4km 직진 → 우측 1차선 도로로 진입 → 300m 지점 우측 의정부성모병원</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel5'} onChange={acHandleChange('panel5')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel5-content"
                                                id="panel5-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    공항버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>포천방향</strong>
                                                                    <p>7100번, 7200번</p>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>정차장 : 9A</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>의정부시외버스터미널 하차 → 대중버스 이용</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </li>
                                                                <li>
                                                                    <strong>포천방향</strong>
                                                                    <p>7300번</p>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>정차장 : 국내선 11-2번 홈</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>의정부시외버스터미널 하차 → 대중버스 이용</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className={style['list-box']} data-type="b" data-line-height="sm" data-size="sm">
                                                            <ul>
                                                                <li>
                                                                    <p>인천공항, 김포공항, 일산, 고양, 의정부역, 의정부시외버스터미널 정차 문의경기고속 : 02-3436-6611</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>        
                                                </div>
                                            </AccordionDetails> 
                                        </Accordion>

                                    </div>
                                )}
                                {/* 의정부성모 :: E */}


                                {/* 부천성모 :: S */}
                                {hospitCds === "014" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    셔틀버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <strong>부천종합운동장 건너편(주차장 출입구) ↔ 부천성모병원</strong>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>부천종합운동장역에서 셔틀버스 타는 곳</p>
                                                                    <div className={style['img-box']}>
                                                                        <object data={imgBucheon01} alt="" aria-hidden='true'/>
                                                                    </div>        
                                                                </li>
                                                                <li>
                                                                    <p>부천종합운동장역에서 셔틀버스 타는 곳</p>
                                                                    <div className={style['img-box']}>
                                                                        <object data={imgBucheon02} alt="" aria-hidden='true'/>
                                                                    </div>        
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className={style['table-box']} data-td-first="normal">
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"25%"} />                                                                
                                                                    <col width={"25%"} />                                                                
                                                                    <col width={"25%"} />                                                                
                                                                    <col width={"25%"} />                                                                
                                                                </colgroup>
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan={2}>
                                                                            <strong>종합운동장역 → 병원</strong>
                                                                        </td>
                                                                        <td colSpan={2}>
                                                                            <strong>병원 → 종합운동장역</strong>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>08:00</td>
                                                                        <td className={style['not']}>미운행</td>
                                                                        <td>08:00</td>
                                                                        <td className={style['not']}>미운행</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>08:20</td>
                                                                        <td className={style['not']}>미운행</td>
                                                                        <td>08:30</td>
                                                                        <td>13:50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>08:40</td>
                                                                        <td>14:00</td>
                                                                        <td>08:50</td>
                                                                        <td>14:10</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>09:00</td>
                                                                        <td>14:20</td>
                                                                        <td>09:10</td>
                                                                        <td>14:30</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>09:20</td>
                                                                        <td>14:40</td>
                                                                        <td>09:30</td>
                                                                        <td>14:50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>09:40</td>
                                                                        <td>15:00</td>
                                                                        <td>09:50</td>
                                                                        <td>15:10</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>10:00</td>
                                                                        <td>15:20</td>
                                                                        <td>10:10</td>
                                                                        <td>15:30</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>10:20</td>
                                                                        <td>15:40</td>
                                                                        <td>10:30</td>
                                                                        <td>15:50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>10:40</td>
                                                                        <td>16:00</td>
                                                                        <td>10:50</td>
                                                                        <td>16:10</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>11:00</td>
                                                                        <td>16:20</td>
                                                                        <td>11:10</td>
                                                                        <td>16:30</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>11:20</td>
                                                                        <td>16:40</td>
                                                                        <td>11:30</td>
                                                                        <td>16:50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>11:40</td>
                                                                        <td>17:00</td>
                                                                        <td>11:50</td>
                                                                        <td>17:10</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>12:00</td>
                                                                        <td>수납확인</td>
                                                                        <td>12:10</td>
                                                                        <td>17:30</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>12:20</td>
                                                                        <td>수납확인</td>
                                                                        <td>12:30</td>
                                                                        <td>17:50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>12:40</td>
                                                                        <td>종료</td>
                                                                        <td>12:50</td>
                                                                        <td>종료</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>13:00</td>
                                                                        <td>종료</td>
                                                                        <td className={style['not']}>미운행</td>
                                                                        <td>종료</td>
                                                                    </tr>
                                                                </tbody>   
                                                            </table>
                                                        </div>

                                                        <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                            <ul>
                                                                <li>
                                                                    <p>셔틀버스 운행상, 시간표와 2분정도 오차가 발생할 수 있으니, 널리 양해바랍니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>근로기준법 제54조 제1항에 의거 근로자 휴게시간 동안 버스 미운행(2021. 9. 1일부) <br />
                                                                    - 미운행 시간 : 13:10 ~ 13:45
                                                                    </p>
                                                                </li>
                                                                <li>
                                                                    <p>토요일 운행 중단</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    시내버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>52, 56, 56-1</strong>
                                                                    <p>소사역, 소사본동 행정복지센터, 역곡역, 가톨릭대, 온수역, 시청, 중·상동, 소풍터미널, 송내역, 원종동, 춘의동</p>
                                                                </li>
                                                                <li>
                                                                    <strong>3, 5, 12, 31-7, 71</strong>
                                                                    <p>소사동, 범박동, 계수동, 작동, 고강동, 부천역, 김포공항, 부명고, 대장동, 송내고, 방화사거리</p>
                                                                </li>
                                                                <li>
                                                                    <strong>60, 95</strong>
                                                                    <p>여월동, 오정동, 삼정동, 약대동, 대장동, 부천테크노파크, 소사역, 소사고, 소사구종점</p>        
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="1">1호선</span>
                                                                    <p>소사역 3번 출구로 나오셔서 도보로 8~10분 이동</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="s-line">서해선</span>
                                                                    <p>소사역 6번 출구</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="7">7호선</span>
                                                                    <div className={style['list-box']} data-type="b" data-line-height="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>셔틀버스 이용 : 3번 출구 → 우회전 → 우회전 → 주차장 입구 부근</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>시내버스 이용 : 4번 출구 → 60번 버스 승차</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li> 
                                                            </ul>
                                                        </div>
                                                        <div className={style['img-box']}>
                                                            <object data={imgBucheon03} alt="" aria-hidden='true'/>
                                                        </div>
                                                    </div>        
                                                </div>
                                            </AccordionDetails> 
                                        </Accordion>

                                    </div>
                                )}
                                {/* 부천성모 :: E */}


                                {/* 인천성모 :: S */}
                                {hospitCds === "016" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>1번</strong>
                                                                    <p>인천성모병원 종점</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>43번</strong>
                                                                    <p>인천성모병원 종점</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>79번</strong>
                                                                    <p>인천성모병원 종점</p>        
                                                                </li>
                                                                <li>
                                                                    <strong>14-1번</strong>
                                                                    <p>인천성모병원 종점</p>
                                                                </li>
                                                                <li>
                                                                    <strong>37번</strong>
                                                                    <p>인천성모병원 종점</p>
                                                                </li>
                                                                <li>
                                                                    <strong>561번</strong>
                                                                    <p>인천성모병원 종점</p>
                                                                </li>
                                                                <li>
                                                                    <strong>45번</strong>
                                                                    <p>부평남부역</p>
                                                                </li>
                                                                <li>
                                                                    <strong>46번</strong>
                                                                    <p>인천예림학교</p>
                                                                </li>
                                                                <li>
                                                                    <strong>47번</strong>
                                                                    <p>인천예림학교</p>
                                                                </li>
                                                                <li>
                                                                    <strong>95번</strong>
                                                                    <p>인천예림학교</p>
                                                                </li>
                                                                <li>
                                                                    <strong>97번</strong>
                                                                    <p>인천예림학교</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="1">1호선</span>
                                                                    <p>인천시청역 (인천지하철 1호선 환승) - 동수역 (2번 출구) - 도보 7~10분</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="1ho" data-width-size="md">인천1호선</span>
                                                                    <p>동수역 (2번 출구) - 도보 7~10분</p>
                                                                </li>
                                                                <li>
                                                                    <span className={style['mark-box']} data-mark="2ho" data-width-size="md">인천2호선</span>
                                                                    <p>인천시청역 (인천지하철 1호선 환승) - 동수역 (2번 출구) - 도보 7~10분</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}
                                {/* 인천성모 :: E */}


                                {/* 대전성모 :: S */}
                                {hospitCds === "018" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    지하철
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>중구청역 2번출구 도보 3분</strong>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    버스
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-type="a">
                                                            <ul>
                                                                <li>
                                                                    <strong>대전성모병원 하차(90m)</strong>
                                                                    <p>311, 513, 612, 33-1,33-2</p>
                                                                </li>
                                                                <li>
                                                                    <strong>중구청 하차(중구청역 1번 출구 230m)</strong>
                                                                    <p>101, 103, 201, 202, 314, 608, 613, 614, 622, 1, 2002, 20</p>
                                                                </li>
                                                                <li>
                                                                    <strong>대고오거리 하차(180m)</strong>
                                                                    <p>108, 311, 615, 313 , 317, 620, 701</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}
                                {/* 대전성모 :: E */}

                            </div> 
                        </div>       
                    </div>
                </div>
                
            
        </>
    );
};

export default Directions;
